import React, { Component, Fragment } from 'react';
import { IntlProvider } from 'react-intl';
import ReactResponsive from 'react-responsive';
import { Redirect, Route, Switch } from 'react-router';
import { formatRoute } from 'react-router-named-routes';
import Admin from './components/Admin';
import BadSize from './components/BadSize';
import Home from './components/Home';
import dictionary from './locales/dictionary';
import Game from './Game';
import { ADMIN, GAME, HOME } from './routes';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			height: 2000,
			width: 2000
		};
	}
	componentDidMount() {
		window.addEventListener(
			'resize',
			() => {
				this.setState({
					height: window.outerWidth,
					width: window.outerHeight
				});
			},
			true
		);
	}
	render() {
		return (
			<Fragment>
				<ReactResponsive query="(max-width: 1023px), (max-height: 549px)">
					<BadSize />
				</ReactResponsive>
				<ReactResponsive query="(min-width: 1024px) and (min-height: 550px)">
					<IntlProvider messages={dictionary} locale="en">
						<Switch>
							<Route exact path={HOME} component={Home} />
							<Route path={GAME} component={Game} />
							<Route path={ADMIN} component={Admin} />
							<Route
								path="/"
								component={() => <Redirect to={formatRoute(HOME)} />}
							/>
						</Switch>
					</IntlProvider>
				</ReactResponsive>
			</Fragment>
		);
	}
}
export default App;
